import { Controller } from "stimulus"

const LEAVE_DURATION = 220

export default class extends Controller {
  static targets = ["progress"]
  static values = { duration: Number }

  connect() {
    this.isPaused = false
    this.isClosing = false
    this.remaining = this.durationValue || 5000
    this.startedAt = Date.now()

    this.startTimer()
    this.startProgress()
  }

  disconnect() {
    this.clearTimers()
  }

  pause() {
    if (this.isPaused || this.isClosing) {
      return
    }

    this.isPaused = true
    this.clearTimers()
    this.remaining = Math.max(this.remaining - (Date.now() - this.startedAt), 0)
  }

  resume() {
    if (!this.isPaused || this.isClosing) {
      return
    }

    this.isPaused = false
    this.startedAt = Date.now()
    this.startTimer()
    this.startProgress()
  }

  close() {
    if (this.isClosing) {
      return
    }

    this.isClosing = true
    this.clearTimers()

    this.element.classList.add("is-leaving")

    this.removeTimeout = setTimeout(() => {
      const stack = this.element.parentElement
      this.element.remove()

      // Retire la pile vide pour ne pas laisser un conteneur fantome.
      if (stack && stack.classList.contains("ng-notice-stack") && stack.children.length === 0) {
        stack.remove()
      }
    }, LEAVE_DURATION)
  }

  startTimer() {
    this.timeout = setTimeout(() => {
      this.close()
    }, this.remaining)
  }

  startProgress() {
    if (!this.hasProgressTarget) {
      return
    }

    const startRemaining = this.remaining
    const total = this.durationValue || 5000

    const update = () => {
      if (this.isPaused || this.isClosing) {
        return
      }

      const elapsed = Date.now() - this.startedAt
      const nextRemaining = Math.max(startRemaining - elapsed, 0)
      const ratio = total > 0 ? nextRemaining / total : 0
      this.progressTarget.style.transform = `scaleX(${ratio})`

      if (nextRemaining > 0) {
        this.animationFrame = requestAnimationFrame(update)
      }
    }

    // La barre est cadencee par requestAnimationFrame : pas de transition CSS.
    this.progressTarget.style.transition = "none"
    this.progressTarget.style.transformOrigin = "left"
    this.animationFrame = requestAnimationFrame(update)
  }

  clearTimers() {
    clearTimeout(this.timeout)
    clearTimeout(this.removeTimeout)

    if (this.animationFrame) {
      cancelAnimationFrame(this.animationFrame)
      this.animationFrame = null
    }
  }
}
